var _circle, _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMerchantDefaultIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.6957,
    cy: 11.6957,
    r: 11.6957,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4116_6636",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 5,
    width: 29,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.124 10.2125C16.4677 10.2125 17.557 9.12323 17.557 7.77949C17.557 6.43575 16.4677 5.34644 15.124 5.34644C13.7802 5.34644 12.6909 6.43575 12.6909 7.77949C12.6909 9.12323 13.7802 10.2125 15.124 10.2125Z",
    fill: "#A6A7A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83127 9.63906C9.67631 9.49253 9.47114 9.41089 9.25788 9.41089C9.04461 9.41089 8.83944 9.49253 8.68449 9.63906L0.33667 17.9869V20.7557C0.33667 21.6161 0.678455 22.4412 1.28684 23.0496C1.89522 23.658 2.72036 23.9998 3.58074 23.9998H19.8011C20.365 23.9981 20.9187 23.849 21.4071 23.5672C21.8956 23.2853 22.3018 22.8806 22.5853 22.3931L9.83127 9.63906Z",
    fill: "#A6A7A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1082 12.1874C17.9759 12.0669 17.8007 11.9998 17.6186 11.9998C17.4364 11.9998 17.2612 12.0669 17.1289 12.1874L10 19.0539V21.3314C10 22.0391 10.2919 22.7178 10.8114 23.2182C11.331 23.7186 12.0356 23.9998 12.7704 23.9998H26.6223C27.1039 23.9984 27.5767 23.8757 27.9938 23.6439C28.4109 23.4121 28.7578 23.0792 29 22.6782L18.1082 12.1874Z",
    fill: "#A9A9A9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4116_6636)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.6957,
    cy: 11.8238,
    r: 11.6957,
    fill: "#AEAEB2"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMerchantDefaultIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/merchant_default_icon.d1c0c6941faeadbcf04c05050190322b.svg";